import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  renderer = inject(Renderer2);
  themeService = inject(ThemeService);
  constructor() {
    setTheme('bs5');
  }
  ngOnInit(): void {
    this.themeService.theme.subscribe((theme: string) =>
      this.setTheme(theme as 'light' | 'dark')
    );
  }

  setTheme(theme: 'light' | 'dark') {
    this.renderer.setAttribute(
      document.documentElement,
      'data-bs-theme',
      theme
    );
    localStorage.setItem('theme', theme);
  }
}
